import { CheckCircleFilled, CloudUploadOutlined, PlusOutlined, SelectOutlined, StopFilled } from "@ant-design/icons";
import { Alert, Breadcrumb, Button, Col, Empty, Image, Input, Popconfirm, Row, Spin, Steps, Table, Upload, notification } from "antd";
import { useEffect, useState } from "react";
import { abmVppUploadToken, deleteAbmVppToken, getAbmVppToken, vppAppIdBing } from "../../axios/api.app";
import { gaEvent } from "../../withTracker";

import { useTranslation } from "react-i18next";
import Column from "antd/lib/table/Column";

const { Step } = Steps;

export const EnrollmentIOSVPP = () => {
  const [step, setStep] = useState<number>(0);
  const [appleId, setAppleId] = useState<string>("");
  const [vppInfo, setVppInfo] = useState<any>({});
  const [regisStatus, setRegisStatus] = useState<number>(0);
  const [uploadSuccess, setUploadSuccess] = useState<boolean>(false);
  const [vppId, setVppId]= useState<string>("");
  const [isLoding, setLoding]= useState<boolean>(false);

  const { t } = useTranslation();

  const onPrevStep = () => {
    setStep(step - 1);
  };

  const onNextStep = () => {
    if (step === 1 && !uploadSuccess) {
      notification.warning({message: t("请先上传证书")})
      return
    }
    setStep(step + 1);
  };
  const beforeUpload = (file: File) => {
    //console.log("beforeUpload",file.type)
    //const isPem = file.type === "application/pkcs7-mime";
    // if (!isPem) {
    //   notification.error({ message: "You can only upload p7m file!" });
    //   return false;
    // }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      notification.error({ message: t("Image must smaller than 2MB!") });
      return false;
    }
    // return isJpgOrPng && isLt2M;
    return true;
  };

  const customRequest = (options: any) => {
    const { onSuccess, onError, file, onProgress } = options;
    try {
      abmVppUploadToken({ File: file, id: vppId }).then(c => {
        notification.success({ message: t("上传成功") });
        onSuccess();
        setUploadSuccess(true);
      })
    } catch (e) {
      onError();
    }
  };
  const finishClick = () => {
    if (!appleId || appleId == '') {
      notification.warning({message: "请输入Apple ID"});
      return
    }
    vppAppIdBing(appleId,vppId).then((res) => {
      setVppId("");
      getVppInfo();
    }, () => {
      notification.error({ message: t("上传失败") });
    })

  };
  const getVppInfo = (search: string = "") => {
    getAbmVppToken({search: search}).then((res) => {
      if (res.length || search) {
        setRegisStatus(1);
        setVppInfo(res)
      } else {
        setRegisStatus(2);
      }
    })
  }

  const updateVppInfo = (id: string) => {
    setVppId(id);
    setRegisStatus(2);
  }
  const addVppInfo = () => {
      setRegisStatus(2);
  }

  const cancelVppInfo = (id: string) => {
    deleteAbmVppToken(id).then(
      () => {
        notification.success({message: t("取消关联成功")});
        if (vppInfo.length) {
          setRegisStatus(1);
          getAbmVppToken();
        } else {
          setRegisStatus(2);
        }
      },
      () => { notification.error({message: t("取消关联失败")}) }
    )
  }

  const onSearch = (value: string) => {
    getVppInfo(value);
  }

  useEffect(() => {
    getVppInfo();
  }, []);
  return (
    <div >
      <div className="breadcrumbTop py-2">
        <Breadcrumb>
          <Breadcrumb.Item>{t("注册")}</Breadcrumb.Item>
          <Breadcrumb.Item>{t("预配置")}</Breadcrumb.Item>
          <Breadcrumb.Item>VPP</Breadcrumb.Item>
        </Breadcrumb>
      </div>

      <Spin spinning={false}>
        <Row style={{ width: "100%" }}>
          {regisStatus == 2 && (
            <div className="borderBox">
              <Alert
                message={t("提示: 绑定苹果设备前,需要先配置APNs和ABM/ASM,该配置完成后,未瓴MDM能够自动关联ABM/ASM的VPP")}
                type="warning"
                showIcon />
              <Steps current={step} className="mt-4">
                <Step title={t("下载 token")} description="" />
                <Step title={t("上传 token")} description="" />
                <Step title={t("保存 Apple ID")} description="" />
              </Steps>
              <Row>
                <Col span={6}></Col>
                <Col span={2} style={{marginTop:"140px",textAlign:"left"}}>
                  {step > 0 && (
                    <a onClick={onPrevStep}>
                      <Image preview={false} width={55} alt="prev" src="/images/prev.png">
                      </Image>
                    </a>
                  )}
                </Col>
                <Col span={8}>
                  <div style={{ height: "500px" }}>
                    {step === 0 && (
                      <div className="text-center py-5">
                        <h4>
                          {t("下载")} servertoken
                        </h4>
                        <div className="text-muted mt-3 text-start">
                          {t("登录Apple Business/School Manager,点击Preferences,然后在点击Payments and Billing,在Server Tokens下载所需组织的vpptoken")}
                        </div>
                        <Button icon={<SelectOutlined />} ghost type="primary" className="w-100 mt-5" size="large" target="_blank" href="https://business.apple.com/">
                          {t("打开")} ABM
                        </Button>
                        <Button icon={<SelectOutlined />} ghost type="primary" className="w-100 mt-5" size="large" target="_blank" href="https://business.apple.com/">
                          {t("打开")} ASM
                        </Button>
                      </div>
                    )}
                    {step === 1 && (
                      <div className="text-center py-5">
                        <h4>
                          {t("上传 token")}
                        </h4>
                        <div style={{textAlign:"center"}} className="text-muted mt-3 text-start">
                          {t("上传上一步从ABM/ASM下载的token到未瓴MDM")}
                        </div>
                        <div>
                          <Upload
                            //accept=".vpptoken"
                            listType="text"
                            showUploadList={true}
                            beforeUpload={beforeUpload}
                            customRequest={customRequest}
                            maxCount={1}>
                            <Button icon={<CloudUploadOutlined />} ghost type="primary" className="w-100 mt-5" size="large">{t("点击上传,证书文件以vpptoken结尾")}</Button>
                          </Upload>
                        </div>
                      </div>
                    )}
                    {step === 2 && (
                      <div className="text-center py-5">
                        <h4>
                          {t("绑定")} Apple ID
                        </h4>
                        <div className="text-muted mt-3 text-start">
                          {t("证书有效期一年,再次输入您的Apple ID,以便收到证书过期的提醒")}
                        </div>
                        <div>Apple ID: <Input value={appleId} onChange={(e) => setAppleId(e.target.value)}></Input></div>
                      </div>
                    )}

                  </div>
                </Col>
                <Col span={2} style={{marginTop:"140px",textAlign:"right"}}>
                  {step < 2 && (
                    <a onClick={onNextStep}>
                      <Image preview={false} width={55} alt="next" src="/images/next.png">
                      </Image>
                    </a>
                  )}
                  {step === 2 && 
                    <a onClick={finishClick}>
                      <Image preview={false} width={55} alt="next" src="/images/next.png">
                      </Image>
                    </a>
                  }
                </Col>
                <Col span={6}></Col>
              </Row>
            </div>
          )}
          {regisStatus == 1 && (
            <>
              <div className="borderBox" style={{ padding: 0 }}>
                <Alert message={<span style={{ fontWeight: 500, fontSize: "1.25rem" }}>VPP {t("绑定成功")}</span>} type="success" showIcon />
              </div>
              <div className="borderBox">
                <Row style={{ marginBottom: 8 }} justify="space-between">
                  <span style={{ fontSize: "16px", fontWeight: 500, lineHeight: "32px" }}>{t("详情")}</span>
                  <div style={{ display: "flex" }}>
                    <Input.Search placeholder={t("请输入")} allowClear onSearch={onSearch}></Input.Search>
                    <Button type="primary" icon={<PlusOutlined />} style={{ marginLeft: "10px" }} onClick={addVppInfo}>{t("添加")}</Button>
                  </div>
                </Row>
                <Table
                  size="middle"
                  dataSource={vppInfo instanceof(Array) ? vppInfo : [vppInfo]}
                  // style={{width: "100%"}} 
                  // pagination={false}
                  rowKey={item => item.id}
                  locale={{ emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t("暂无数据")}></Empty> }}
                >
                  <Column title={t("苹果ID")} key="appleId" dataIndex="appleId"></Column>
                  <Column title={t("组织名称")} key="organizationName" dataIndex="organizationName"></Column>
                  {/* <Column title={t("MDM名称")} key="serverName" dataIndex="serverName"></Column> */}
                  <Column title={t("有效期")} key="renewedBy" dataIndex="renewedBy"></Column>
                  <Column title={t("状态")} key="validity" dataIndex="validity" 
                    render={(v) => (<>
                      {v && (
                        <span><CheckCircleFilled style={{ color: "#4CB8BE", fontSize: 16 }} />&nbsp;&nbsp;Active</span>
                      )}
                      {!v && (
                        <span><StopFilled style={{ color: "#C9A063", fontSize: 16 }} />&nbsp;&nbsp;Disabled</span>
                      )}
                    </>)}
                  ></Column>
                  <Column title={t("操作")} key="id" dataIndex="id" align="center" ellipsis width={180} render={(id) => {
                    return (
                      <div style={{ display: "flex", justifyContent: "center" }}>
                        <Button type="link" className="updateButton" onClick={() => { updateVppInfo(id); }}>{t("更新")}</Button>
                        <Popconfirm
                            title={`${t("确认取消关联?")}？`}
                            onConfirm={() => { cancelVppInfo(id); }}
                            okText={t("确认")}
                            cancelText={t("取消")}
                        >
                            <Button type="link" block>{t("取消关联")}</Button>
                        </Popconfirm>
                      </div>
                    )
                  }}></Column>
                </Table>
              </div>
            </>
          )}
        </Row>
      </Spin>
    </div>
  );
};
